import React from 'react';
import ReactTooltip from 'react-tooltip';
import { Icon } from '../../_components';
import { getArticleIcon } from '../../_helpers';
// import { useApp } from '../../_contexts';

export function SearchResult({ result, type, isEntity, isArticle, onSelect }) {
  if (!isEntity && !isArticle) return null;
  if (isEntity)
    return <EntityResult entity={result} type={type} onSelect={onSelect} />;
  if (isArticle) return <ArticleResult article={result} onSelect={onSelect} />;
}

function ArticleResult({ article, onSelect }) {
  ReactTooltip.rebuild();

  const handleNavigation = () => {
    if (article.url) {
      onSelect('article', article);
      const link = document.createElement('a');
      link.target = '_blank';
      link.classList.add('chronos-null');
      link.href = article.url;
      link.click();
      link.remove();
    }
  };
  console.log('Artice: ', article);
  const displayIcon = getArticleIcon(article);
  const displayType =
    article.subtype && article.subtype.length > 0
      ? article.subtype
      : article.template && article.template !== 'generic'
      ? article.template
      : 'article';

  const { state, is_draft, is_wip } = article;
  const tooltipID = `chronos-article-${article.id}`;
  return (
    <div
      className="chronos-global-search-result chronos-global-article-result"
      onClick={handleNavigation}
    >
      <div className="chronos-search-result-icon">
        {displayIcon && <Icon icon={displayIcon.icon} />}
      </div>
      <div className="chronos-search-result-details">
        <h5 className="chronos-search-result-title">{article.title}</h5>
        <div className="chronos-search-result-flags">
          <span className="chronos-search-result-type">{displayType}</span>
          {/* Article Flags!! (WIP, Published, etc.) */}
          {state === 'public' && (
            <Icon
              icon="far fa-lock-open fa-fw"
              data-for={tooltipID}
              data-tip="Public"
            />
          )}
          {state === 'private' && (
            <Icon
              icon="far fa-lock fa-fw"
              data-for={tooltipID}
              data-tip="Private"
            />
          )}
          {is_draft && (
            <Icon
              icon="far fa-drafting-compass fa-fw"
              data-for={tooltipID}
              data-tip="Draft"
            />
          )}
          {!is_draft && (
            <Icon
              icon="far fa-star fa-fw"
              data-for={tooltipID}
              data-tip="Published"
            />
          )}
          {is_wip && (
            <Icon icon="far fa-cog fa-fw" data-for={tooltipID} data-tip="WIP" />
          )}
          {!is_wip && (
            <Icon
              icon="far fa-check fa-fw"
              data-for={tooltipID}
              data-tip="Done!"
            />
          )}
        </div>
      </div>
      <ReactTooltip effect="solid" id={tooltipID} />
    </div>
  );
}

function EntityResult({ entity, type, onSelect }) {
  // console.log('ENTITY: ', entity);
  const classNames = [
    'chronos-global-search-result',
    'chronos-global-entity-result',
    `chronos-global-${type}-result`,
  ];

  let displayIcon = null;
  if (entity.icon && entity.icon.length > 0) {
    displayIcon = entity.icon;
  } else {
    if (type === 'event') {
      displayIcon = 'fal fa-sparkles fa-fw';
    }
    if (type === 'location') {
      displayIcon = 'far fa-map-marker fa-fw';
    }
  }

  // const { openSidebar } = useApp();

  const handleSidebarDisplay = () => {
    if (onSelect) onSelect(type, entity);
  };

  const { matchItem, matches } = entity;

  const matchDisplay = matchItem
    ? typeof matchItem === 'string'
      ? matchItem
      : matchItem.title || matchItem.name
    : undefined;
  return (
    <div className={classNames.join(' ')} onClick={handleSidebarDisplay}>
      <div className="chronos-search-result-icon">
        <Icon icon={displayIcon} />
      </div>
      <div className="chronos-search-result-details">
        <h5 className="chronos-search-result-title">{entity.title}</h5>
        <div className="chronos-search-result-match">
          <span className="chronos-search-result-type">{type}</span>
          <span className="chronos-match-type">Matches: {matches}</span>
          {matchItem && (
            <span className="chronos-match-item-value">{matchDisplay}</span>
          )}
        </div>
      </div>
    </div>
  );
}
